module.exports = __webpack_public_path__ + "static/media/sliders-regular.9982d92f.svg";